import gql from 'graphql-tag'
import api from './apiClient'

export default {
  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: IvaRecordInput!) {
            Iva {
              create(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Iva.create),

  findOne: (_idEmisor, start, end) =>
    api
      .send({
        query: gql`
          query findOne($_idEmisor: ID!, $start: Date, $end: Date) {
            Iva {
              findOne(_idEmisor: $_idEmisor, start: $start, end: $end) {
                _id
                saldo
              }
            }
          }
        `,
        variables: {
          _idEmisor,
          start,
          end
        }
      })
      .then(result => result.data.data.Iva.findOne)
}
